module.exports = __webpack_public_path__ + "static/media/MilleniumHealthWhite.24643661.svg";